export function faqFunc() {
    var faqSet, decision, fullOpenJs;
    fullOpenJs = $('#fullOpenJs');
    faqSet = $('.faqLayout dl dt');

    fullOpenJs.on('click', function () {
        $('.faqLayout dl').find('dd').slideDown(500);
        $('.faqLayout dl').find('dt').addClass('open');
    });

    faqSet.on('click', function () {
        decision = $(this).next('dd').css('display');
        if (decision === 'block') {
            $(this).next('dd').slideUp(500);
            $(this).removeClass('open');
        } else {
            $(this).next('dd').slideDown(500);
            $(this).addClass('open');
        }
    });
}